module.exports = __webpack_public_path__ + "static/media/button-wizard-3.7700eb1a.png";